<app-component-loader *ngIf="!isReady"></app-component-loader>

<div class="vehicle-variants-overview-spot" *ngIf="isReady">
    <app-rich-text
        [html]="data?.spotText"
        *ngIf="data?.spotText"
    ></app-rich-text>

    <!-- Variants -->
    <ul class="vehicle-variants-overview__list">
        <li
            class="vehicle-variants-overview__item"
            *ngFor="let variant of variants"
        >
            <!-- Variant campaign -->
            <div
                class="vehicle-variants-overview__campaign-banner"
                *ngIf="variant.campaigns?.length"
            >
                <div
                    class="vehicle-variants-overview__campaign"
                    *ngFor="let campaign of variant.campaigns"
                >
                    <span
                        class="vehicle-variants-overview__campaign-header"
                        [innerText]="'car_data.campaign_label_text' | translate"
                    ></span>

                    <span
                        class="vehicle-variants-overview__campaign-text"
                        [innerText]="campaign.name"
                    ></span>

                    <a
                        class="vehicle-variants-overview__campaign-link"
                        *ngIf="campaignPageUrl"
                        [routerLink]="campaignPageUrl"
                        [queryParams]="{ id: campaign.id }"
                        [innerText]="'buttons.read_more_text' | translate"
                    ></a>
                </div>
            </div>

            <!-- Variant content -->
            <div class="vehicle-variants-overview__item-content">
                <div class="vehicle-variants-overview__item-image">
                    <app-responsive-image
                        *ngIf="variant.image?.src"
                        [image]="variant.image"
                        [breakpoints]="imageBreakpoints"
                    ></app-responsive-image>

                    <app-responsive-image
                        *ngIf="
                            !variant.image?.src &&
                            vehicleModel.modelDisplayImage?.src
                        "
                        [image]="vehicleModel.modelDisplayImage"
                        [breakpoints]="imageBreakpoints"
                    ></app-responsive-image>
                </div>

                <div class="vehicle-variants-overview__item-details">
                    <div
                        class="component-header--small theme-text"
                        [innerText]="variant.modelName"
                    ></div>

                    <h2
                        class="vehicle-variants-overview__item-details-header"
                        [innerText]="variant.variantName"
                    ></h2>

                    <p
                        *ngIf="variant.introText"
                        [innerText]="variant.introText"
                    ></p>

                    <div
                        class="vehicle-variants-overview__accessories"
                        *ngIf="variant.accessoriesList"
                    >
                        <app-vehicle-accessories-list
                            class="vehicle-variants-overview__accessories-list"
                            [listHeaderText]="variant.accessoriesListHeader"
                            [listItems]="variant.accessoriesList"
                            [amountToShow]="12"
                            [showAllButton]="true"
                        ></app-vehicle-accessories-list>
                    </div>
                </div>

                <div class="vehicle-variants-overview__item-actions">
                    <div class="vehicle-variants-overview__item-action">
                        <div
                            class="
                                vehicle-variants-overview__item-action-header
                            "
                            [innerText]="
                                'car_data.starting_price_from' | translate
                            "
                        ></div>

                        <div
                            class="vehicle-variants-overview__item-price"
                            *ngIf="variant.startPrice"
                        >
                            {{ variant.startPrice | defaultcurrency }}

                            <div
                                class="vat-price"
                                *ngIf="isB2B$ | async"
                                [innerText]="'generic.vat_excluded' | translate"
                            ></div>
                        </div>
                    </div>
                    <div
                        class="vehicle-variants-overview__item-action"
                        *ngIf="!(isB2B$ | async) && variant.startPrice"
                    >
                        <div
                            class="
                                vehicle-variants-overview__item-action-header
                            "
                        >
                            {{ 'car_data.starting_loan_from' | translate }}

                            <button
                                type="button"
                                class="button button--mini"
                                (click)="showLoanSimulator(variant.startPrice)"
                            >
                                i
                            </button>
                        </div>

                        <div class="vehicle-variants-overview__item-price">
                            <app-vehicle-loan-calculation
                                [objectPrice]="variant.startPrice"
                            ></app-vehicle-loan-calculation>
                        </div>

                        <button
                            class="
                                button button--as-link
                                vehicle-variants-overview__item-price-button
                            "
                            [innerText]="
                                'car_data.calculate_loan_button_text'
                                    | translate
                            "
                            (click)="showLoanSimulator(variant.startPrice)"
                        ></button>
                    </div>
                    <div
                        class="vehicle-variants-overview__item-action"
                        *ngIf="
                            variant.leasingPricePerMonth &&
                            variant.allowLeasingOnBnDk
                        "
                    >
                        <div
                            class="
                                vehicle-variants-overview__item-action-header
                            "
                            [innerText]="
                                'car_data.starting_leasing_from' | translate
                            "
                        ></div>

                        <div class="vehicle-variants-overview__item-price">
                            {{
                                variant.leasingPricePerMonth | defaultcurrency
                            }}/md.
                        </div>

                        <a
                            class="vehicle-variants-overview__item-leasing-link"
                            *ngIf="data?.leasingPageLink"
                            [innerText]="'buttons.read_more_text' | translate"
                            [routerLink]="data?.leasingPageLink?.url"
                        ></a>
                    </div>

                    <div
                        class="vehicle-variants-overview__item-action"
                        *ngIf="variant.showTestDriveButton"
                    >
                        <button
                            class="button--primary button--themed"
                            [innerText]="'buttons.book_test_drive' | translate"
                            (click)="bookTestDrive()"
                        ></button>
                    </div>

                    <div
                        class="vehicle-variants-overview__item-action"
                        *ngIf="variant.showPriceCheckButton"
                    >
                        <button
                            class="button--primary button--themed"
                            [innerText]="'buttons.car_price_check' | translate"
                            (click)="exhangeCar()"
                        ></button>
                    </div>

                    <div
                        class="vehicle-variants-overview__item-action"
                        *ngIf="variant.showGetOfferButton"
                    >
                        <button
                            class="button--primary button--themed"
                            [innerText]="
                                'buttons.get_price_offer_on_vehicle' | translate
                            "
                            (click)="getOffer()"
                        ></button>
                    </div>

                    <app-link
                        *ngIf="variant.priceListLink"
                        [link]="variant.priceListLink"
                        class="vehicle-variants-overview__item-price-list-link"
                    ></app-link>
                </div>
            </div>
        </li>
    </ul>

    <!-- Generic information -->
    <div class="vehicle-variants-overview-spot__information">
        <app-vehicle-energy-ratings
            class="vehicle-variants-overview-spot__information-item"
            *ngIf="vehicleModel.energyRating"
            [data]="vehicleModel.energyRating"
        ></app-vehicle-energy-ratings>

        <p
            class="vehicle-variants-overview-spot__information-item"
            *ngIf="
                vehicleModel.fuelConsumption && vehicleModel.co2EmissionLevels
            "
        >
            {{
                'car_data.fuel_and_co2_emissions'
                    | translate
                        : {
                              fuelConsumption: vehicleModel.fuelConsumption,
                              Co2Emissions: vehicleModel.co2EmissionLevels
                          }
            }}
        </p>

        <!-- New cars disclaimer text -->
        <app-rich-text
            class="vehicle-variants-overview-spot__information-item"
            *ngIf="
                newVehiclesDisclaimerText$ | async as newVehiclesDisclaimerText
            "
            [html]="newVehiclesDisclaimerText"
        ></app-rich-text>
    </div>
</div>
